var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSeeDentist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 179.271,
    height: 155.543,
    viewBox: "0 0 179.271 155.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a28df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7623c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28c4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b5cf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faba3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9822a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe4685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff749e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24e554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fdb80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.291,
    y1: 0.106,
    x2: 0.807,
    y2: 0.772,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5694ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feffff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(-268 -315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M73,515.68V629.965a11.2,11.2,0,0,0,11.2,11.2H241.066a11.2,11.2,0,0,0,11.2-11.2V515.68Z",
    transform: "translate(195 -170.801)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M73,515.68V629.965a11.2,11.2,0,0,0,11.2,11.2H241.066a11.2,11.2,0,0,0,11.2-11.2V515.68Z",
    transform: "translate(195 -170.801)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(268 344.879)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M73,515.68V629.965a11.2,11.2,0,0,0,11.2,11.2H241.066a11.2,11.2,0,0,0,11.2-11.2V515.68Z",
    transform: "translate(-73 -515.68)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M229.862,266H95.409A22.409,22.409,0,0,0,73,288.409v7.47H252.271v-7.47A22.409,22.409,0,0,0,229.862,266Z",
    transform: "translate(195 49)",
    fill: "#adedff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 5.976,
    cy: 5.976,
    r: 5.976,
    transform: "translate(300.866 323.963)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 5.976,
    cy: 5.976,
    r: 5.976,
    transform: "translate(282.938 323.963)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(282.845 323.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M203.12,352.259a6.07,6.07,0,1,1,6.07-6.07A6.077,6.077,0,0,1,203.12,352.259Zm0-11.951A5.883,5.883,0,1,0,209,346.191,5.89,5.89,0,0,0,203.12,340.308Z",
    transform: "translate(-197.05 -340.12)",
    fill: "#db486d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(300.772 323.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M352.93,352.259a6.07,6.07,0,1,1,6.07-6.07A6.077,6.077,0,0,1,352.93,352.259Zm0-11.951a5.883,5.883,0,1,0,5.883,5.883A5.89,5.89,0,0,0,352.93,340.308Z",
    transform: "translate(-346.86 -340.12)",
    fill: "#cc8343"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 5.976,
    cy: 5.976,
    r: 5.976,
    transform: "translate(318.793 323.963)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 5.976,
    cy: 5.976,
    r: 5.976,
    transform: "translate(318.793 323.963)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(318.7 323.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M502.74,352.259a6.07,6.07,0,1,1,6.07-6.07A6.077,6.077,0,0,1,502.74,352.259Zm0-11.951a5.883,5.883,0,1,0,5.883,5.883A5.89,5.89,0,0,0,502.74,340.308Z",
    transform: "translate(-496.67 -340.12)",
    fill: "#3cb857"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(302.683 360.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M374.082,365.052v7.105c1.808,1.032,3.617,1.938,5.3,2.841v12.014a5.675,5.675,0,0,0-4.52,5.555,5.763,5.763,0,0,0,5.683,5.814,5.681,5.681,0,0,0,5.683-5.814,5.539,5.539,0,0,0-3.874-5.3.48.48,0,0,0,.128-.389V376.42c21.186,9.817,31.906,7.105,31.906,37.977H304.973c0-32.681,11.237-28.16,33.328-38.625v4.909a14.651,14.651,0,0,0-12.919,14.467v13.564a1.572,1.572,0,0,0,1.551,1.552H332.1a1.551,1.551,0,1,0,0-3.1h-3.617V395.149a11.691,11.691,0,0,1,23.382,0v12.014h-3.23a1.551,1.551,0,0,0,0,3.1h4.78a1.493,1.493,0,0,0,1.549-1.552V395.149a14.753,14.753,0,0,0-13.562-14.6v-6.327a35.029,35.029,0,0,0,3.744-2.068v-6.2c-4.65-3.23-5.683-9.3-7.362-15.5h0c-.774,0-1.291-1.163-1.291-2.454v-.517a13.756,13.756,0,0,1-1.292-3.231c-.516-1.807-2.2-5.682-.645-7.363a1.337,1.337,0,0,1,2.2,0c-1.938-10.2-4.521-23.509,9.559-27.514,0-8.784,33.069-4.909,37.073,9.172,1.809,5.424-.516,18.213-.516,18.213a1.165,1.165,0,0,1,1.809-.645c1.809,1.292-.13,6.459-.648,8.137a8.339,8.339,0,0,1-1.419,3.36V348c0,1.29-.517,2.325-1.163,2.454-1.421,5.554-2.971,11.756-7.363,14.6Zm6.459,30.229a2.65,2.65,0,0,1-2.713-2.714,2.622,2.622,0,0,1,2.713-2.584,2.65,2.65,0,1,1,0,5.3Z",
    transform: "translate(-304.798 -304.522)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_542_-_Outline",
    "data-name": "Path 542 - Outline",
    d: "M414.235,414.248H304.473v-.175a73.193,73.193,0,0,1,1.317-15.454,28.261,28.261,0,0,1,1.648-5.228,18.436,18.436,0,0,1,2.311-3.96,19.235,19.235,0,0,1,6.58-5.283,79,79,0,0,1,9.122-3.776c3.667-1.355,7.823-2.891,12.449-5.082l.25-.118v5.34l-.153.019a14.692,14.692,0,0,0-9.065,4.708,14.211,14.211,0,0,0-3.7,9.586v13.564a1.4,1.4,0,0,0,1.376,1.377h5.166a1.376,1.376,0,1,0,0-2.752h-3.792V394.824a11.682,11.682,0,0,1,3.508-8.358,12.014,12.014,0,0,1,13.031-2.519,11.74,11.74,0,0,1,6.27,6.268,11.825,11.825,0,0,1,.922,4.608v12.189h-3.4a1.376,1.376,0,0,0,0,2.752h4.78a1.316,1.316,0,0,0,1.373-1.377V394.824a14.2,14.2,0,0,0-1.052-5.393,14.368,14.368,0,0,0-2.871-4.448,14.8,14.8,0,0,0-9.478-4.58l-.16-.014v-6.6l.136-.068a35.6,35.6,0,0,0,3.609-1.986v-6.016c-4.07-2.877-5.375-7.923-6.756-13.263-.183-.708-.372-1.439-.568-2.164a1.359,1.359,0,0,1-.955-.83,4.094,4.094,0,0,1-.374-1.789V347.2l-.133-.262a12.871,12.871,0,0,1-1.154-2.965c-.083-.289-.2-.64-.321-1.013a20.338,20.338,0,0,1-.9-3.416,3.645,3.645,0,0,1,.616-3.1l0-.005a1.822,1.822,0,0,1,1.267-.624,1.384,1.384,0,0,1,.781.252c-.957-5.042-1.983-10.7-1.118-15.672a16,16,0,0,1,1.082-3.679,12.7,12.7,0,0,1,2.047-3.249,13.368,13.368,0,0,1,3.21-2.662,18.788,18.788,0,0,1,4.436-1.888,3.316,3.316,0,0,1,.794-2.043,5.746,5.746,0,0,1,2.152-1.509,18.523,18.523,0,0,1,7.159-1.17,40.365,40.365,0,0,1,8.171.9,41.462,41.462,0,0,1,8.291,2.659,25.751,25.751,0,0,1,6.892,4.37,13.177,13.177,0,0,1,3.954,6.047,18.16,18.16,0,0,1,.69,5.183,55.828,55.828,0,0,1-.263,6.026c-.249,2.716-.612,5.121-.806,6.307a1.114,1.114,0,0,1,.751-.277,1.891,1.891,0,0,1,.831.224l.012.006.011.008a2.109,2.109,0,0,1,.781,1.49,7.225,7.225,0,0,1-.072,2.1,27.8,27.8,0,0,1-1.095,4.132c-.077.235-.143.438-.2.607a8.782,8.782,0,0,1-1.413,3.375v.327a4.1,4.1,0,0,1-.357,1.738,1.557,1.557,0,0,1-.838.858l-.016.064a55.887,55.887,0,0,1-2.567,8.255,17.855,17.855,0,0,1-2,3.573,10.979,10.979,0,0,1-2.746,2.657v6.909c1.163.661,2.328,1.272,3.455,1.864.606.318,1.179.618,1.748.925l.092.05v12.262l-.141.028a5.438,5.438,0,0,0-3.128,1.892,5.525,5.525,0,0,0-1.251,3.491,5.659,5.659,0,0,0,1.629,4,5.521,5.521,0,0,0,1.753,1.2,5.335,5.335,0,0,0,2.126.44,5.414,5.414,0,0,0,3.927-1.643,5.7,5.7,0,0,0,1.581-4,5.358,5.358,0,0,0-3.754-5.13l-.267-.089.2-.2c.074-.075.077-.139.077-.266V375.821l.249.115c3.865,1.791,7.416,3.178,10.55,4.4a86.488,86.488,0,0,1,9.339,4.043,20.6,20.6,0,0,1,6.728,5.412,18.735,18.735,0,0,1,2.362,3.957,27.631,27.631,0,0,1,1.684,5.171,69.2,69.2,0,0,1,1.345,15.151Zm-109.412-.35H413.885a68.449,68.449,0,0,0-1.336-14.9,27.29,27.29,0,0,0-1.663-5.106,18.389,18.389,0,0,0-2.318-3.884,20.261,20.261,0,0,0-6.618-5.32,86.258,86.258,0,0,0-9.3-4.025c-3.071-1.2-6.543-2.555-10.321-4.3v10.188a.832.832,0,0,1-.039.3,5.836,5.836,0,0,1,2.686,2.006,5.661,5.661,0,0,1,1.1,3.382,6.046,6.046,0,0,1-1.68,4.24,5.761,5.761,0,0,1-4.178,1.749,5.684,5.684,0,0,1-2.265-.469,5.87,5.87,0,0,1-1.864-1.28,6.007,6.007,0,0,1-1.729-4.241,5.876,5.876,0,0,1,1.33-3.713,5.8,5.8,0,0,1,3.19-1.984V374.778c-.538-.289-1.081-.573-1.653-.874-1.159-.608-2.357-1.237-3.554-1.92l-.088-.05v-7.3l.08-.052a10.583,10.583,0,0,0,2.735-2.624,17.512,17.512,0,0,0,1.963-3.5,55.632,55.632,0,0,0,2.549-8.2l.069-.27.108-.022a1.154,1.154,0,0,0,.7-.7,3.743,3.743,0,0,0,.322-1.586v-.449l.038-.048a8.334,8.334,0,0,0,1.385-3.29l0-.012c.053-.173.121-.379.2-.619a27.515,27.515,0,0,0,1.082-4.077c.264-1.686.077-2.776-.556-3.239a1.537,1.537,0,0,0-.662-.181c-.388,0-.68.244-.9.745l-.333-.1c.006-.032.584-3.236.934-7.06a55.474,55.474,0,0,0,.261-5.986,17.813,17.813,0,0,0-.674-5.081l0-.008a12.831,12.831,0,0,0-3.855-5.888,25.4,25.4,0,0,0-6.8-4.308,41.932,41.932,0,0,0-16.319-3.528,18.184,18.184,0,0,0-7.019,1.141,5.4,5.4,0,0,0-2.023,1.412,2.977,2.977,0,0,0-.716,1.951v.132l-.127.036c-6.157,1.751-9.641,5.427-10.652,11.237-.878,5.046.224,10.845,1.2,15.962l.022.114-.315.133a1.251,1.251,0,0,0-.91-.5,1.491,1.491,0,0,0-1.017.519c-1.227,1.334-.271,4.241.362,6.165.124.377.241.733.326,1.029l0,.006a12.565,12.565,0,0,0,1.127,2.893c.053.1.1.2.153.3l.018.037v.558a3.794,3.794,0,0,0,.337,1.632c.121.241.382.646.779.646h.134l.035.129c.208.767.408,1.54.6,2.288a49.524,49.524,0,0,0,2.364,7.533,15.627,15.627,0,0,0,1.788,3.117,10.991,10.991,0,0,0,2.541,2.465l.075.052v6.386l-.078.052a34.451,34.451,0,0,1-3.666,2.031v6.059a15.148,15.148,0,0,1,9.543,4.674,14.717,14.717,0,0,1,2.941,4.556,14.552,14.552,0,0,1,1.078,5.525v13.564a1.669,1.669,0,0,1-1.724,1.727h-4.78a1.726,1.726,0,0,1,0-3.453h3.054V394.824a11.476,11.476,0,0,0-.895-4.472,11.389,11.389,0,0,0-6.083-6.081,11.486,11.486,0,0,0-4.474-.894,11.626,11.626,0,0,0-8.176,3.34,11.332,11.332,0,0,0-3.4,8.108v11.839h3.442a1.753,1.753,0,0,1,1.187.484,1.7,1.7,0,0,1,0,2.484,1.752,1.752,0,0,1-1.187.485h-5.166a1.752,1.752,0,0,1-1.187-.485,1.7,1.7,0,0,1-.539-1.242V394.824A14.561,14.561,0,0,1,328.673,385a15.043,15.043,0,0,1,9.128-4.8v-4.479c-4.54,2.135-8.62,3.643-12.227,4.976a78.766,78.766,0,0,0-9.081,3.758,18.9,18.9,0,0,0-6.466,5.187,18.09,18.09,0,0,0-2.267,3.886,27.915,27.915,0,0,0-1.627,5.163A72.419,72.419,0,0,0,304.823,413.9Zm75.393-18.767a2.825,2.825,0,0,1-2.888-2.889,2.8,2.8,0,0,1,2.888-2.759,2.977,2.977,0,0,1,2.009.807,2.667,2.667,0,0,1,.879,1.953,2.851,2.851,0,0,1-.876,2.064A2.921,2.921,0,0,1,380.216,395.131Zm0-5.3a2.449,2.449,0,0,0-2.537,2.409,2.474,2.474,0,0,0,2.537,2.539,2.568,2.568,0,0,0,1.768-.726,2.5,2.5,0,0,0,.77-1.812,2.32,2.32,0,0,0-.768-1.7A2.623,2.623,0,0,0,380.216,389.833Z",
    transform: "translate(-304.473 -304.197)",
    fill: "#d1e8f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(279.561 356.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M2.138,41.974A2.136,2.136,0,0,1,0,39.84,19.73,19.73,0,0,1,12.595,21.426a9.648,9.648,0,0,1-2.886-6.893V9.688a9.708,9.708,0,0,1,19.417,0v4.845a9.648,9.648,0,0,1-2.87,6.877A19.386,19.386,0,0,1,38.834,39.552v.289A2.136,2.136,0,0,1,36.7,41.974Z",
    stroke: "#d1e8f9",
    strokeWidth: 1,
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_534_-_Outline",
    "data-name": "Rectangle 534 - Outline",
    d: "M1.745-.5h35.1a2.107,2.107,0,0,1,2.245,1.927V39.964a2.107,2.107,0,0,1-2.245,1.927H1.745A2.107,2.107,0,0,1-.5,39.964V1.427A2.107,2.107,0,0,1,1.745-.5Zm35.1,41.69a1.341,1.341,0,0,0,1.429-1.226V1.427A1.341,1.341,0,0,0,36.846.2H1.745A1.341,1.341,0,0,0,.316,1.427V39.964A1.341,1.341,0,0,0,1.745,41.19Zm0,.35a1.724,1.724,0,0,0,1.837-1.577v0a1.724,1.724,0,0,1-1.837,1.577H1.745A1.724,1.724,0,0,1-.092,39.964,1.724,1.724,0,0,0,1.745,41.54Z",
    transform: "translate(279.711 356.489)",
    fill: "#d1e8f9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeeDentist);
export default __webpack_public_path__ + "static/media/icon-see-dentist.608f25691d36e19601f8e1d1ac6a77fe.svg";
export { ForwardRef as ReactComponent };